import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-pending-list',
  templateUrl: './new-pending-list.component.html',
  styleUrls: ['./new-pending-list.component.scss']
})
export class NewPendingListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
